import React from 'react';

import styles from './styles.scss';

export default ({ children, className, ...props }) => (
  <div className={ `${styles.box} ${className || ''}` } { ...props }>
    { children }
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Box/index.jsx